import { render } from "./ServicesManagement.vue?vue&type=template&id=f34a607a&scoped=true"
import script from "./ServicesManagement.vue?vue&type=script&lang=js"
export * from "./ServicesManagement.vue?vue&type=script&lang=js"

import "./ServicesManagement.vue?vue&type=style&index=0&id=f34a607a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f34a607a"]])

export default __exports__